import { css } from 'lit';

export default css`
  .cardLogo {
    width: 4rem;
    height: 2.5rem;
  }
  .cardImg {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .cardDisplayLogo {
    width: 4rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 0 0.25rem;
  }
  .checkout-with-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.625rem;
    height: 1rem;
    flex-shrink: 0;
  }
  .card-frame {
    border: 0.0583rem solid rgba(0, 0, 0, 0.13);
    border-radius: 0.2333rem;
  }
  .cart-card {
    width: 3.5rem;
    height: 1.75rem;
  }
  .cart-card-amex {
    width: 3.5rem;
    height: 1.75rem;
    background: var(--mh-amex-blue, #26a6d1);
  }
  .cart-card-po {
    width: 6.6875rem;
    height: 1.75rem;
  }
  .cart-card-po-label {
    font-size: var(--mh-font-size-small, 14px);
  }
  .cart-discover-logo {
    width: 2.8rem;
    height: 0.4375rem;
  }
  .cart-mastercard-logo {
    width: 2.2169rem;
    height: 1.37rem;
  }
  .cart-visa-logo {
    width: 2.8581rem;
    height: 1.75rem;
  }
`;
